import React from 'react';
import SimulatorsViewerArrangement from '../FullPagesComponents/SimulatorsViewerArrangement';
import QuickActionBarFP from '../FullPagesComponents/Keyboard/QuickActionBarFP';
import PromotionCardsFP from '../FullPagesComponents/Keyboard/PromotionCardsFP';
import EmptyStateFP from '../FullPagesComponents/Keyboard/EmptyStateFP';
//= ========================================================================
const KeyboardPromotionDF = ({
  globJSON,
  language,
  simPlatform,
  slideshowRefs,
}) => (
  <SimulatorsViewerArrangement>
    <QuickActionBarFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
    />
    <PromotionCardsFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      language={language}
    />
    <EmptyStateFP
      globJSON={globJSON}
      simPlatform={simPlatform}
      slideshowRefs={slideshowRefs}
      language={language}
    />
  </SimulatorsViewerArrangement>
);
export default KeyboardPromotionDF;
